module.exports = __webpack_public_path__ + "static/media/Cloudy.4bbbb154.png";